



















































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import dayjs from "dayjs";
import { TbGoodsSpecs } from '@/http';
import addSpecsPanel from "./addSpecsPanel.vue";
import logoutPanel from "./logoutPanel.vue";
import { idText } from 'typescript';
@Component({
    components: {
        addSpecsPanel,logoutPanel
    },
})
export default class selectSpecsPanel extends Vue {
    public $refs: {
    };

    @Prop({
        default:'add'
    })
    type:String;

    @Prop({
        type:Object,
        default:()=>{
            return {
               oldSpecsSelectedList:[],
               addGoodsItemsList:[],
            };
        }
    })
    oldInfo:any;

    show = false;

    list=[];

    /**添加规格 */
    addSpecsShow = false;
    isAddName = true;
    specsInfo:any = {};

    selectedList=[];

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;

    /**
     * 1：最多两组规格
     * 2：删除提醒
     * 3：不能删提醒
     */
    tipType=1;
    tipItem:any={};
    tipV:any={};

        
    created() {
    }
    mounted() {
    }

    showFun(list){
        this.show = true;
        this.init();
        this.selectedList = JSON.parse(list);
    }

    getStatus(item,v){
        let val = false;
        if(this.selectedList.length>0){
            let index =  this.selectedList.findIndex(vv=>vv.id==item.id);
            if(index>-1){
                let childIndex = this.selectedList[index].childList.findIndex(vv=>vv.id==v.id);
                if(childIndex>-1){
                    val = true;
                }
            }
        }
        return val;
    }

    async init(){
        this.list = [];
        let res = await TbGoodsSpecs.GetTbGoodsSpecsList();
        this.list = res;
    }

    addSpecs(){
        this.isAddName = true;
        this.addSpecsShow = true;
        this.$nextTick(()=>{
            this.$refs['addSpecsref'].init2();
        })
    }
    addSpecsVal(item){
        this.specsInfo = item;
        this.isAddName = false;
        this.addSpecsShow = true;
        this.$nextTick(()=>{
            this.$refs['addSpecsref'].init2();
        })
    }
    cancelFun(){
        this.addSpecsShow = false;
    }
    async confirmAddSpecs(addItem){
        await this.init();
        if(addItem){
            await this.setItemOn(addItem)
        }
    }
    /**新增完规格值，默认选中 */
    async setItemOn(addItem){
        let index = this.selectedList.findIndex(v=>v.id==addItem.id);
        if(index>-1){
            this.selectedList[index].childList.push(addItem.childList[0]);
        }else{
            if(this.selectedList.length<2){
                this.selectedList.push(addItem);
            }
        }
    }
    closeFun(){
        this.show = false;
    }
    saveFun(){
        this.$emit('confirmChoose',JSON.stringify(this.selectedList));
        this.closeFun();
    }
    chooseSpecs(item,v){
        if(this.selectedList.length==2&&this.selectedList.findIndex(vv=>vv.id==item.id)==-1){
            this.tipTitle = "操作提醒";
            this.tipText = `最多可选两组规格，无法继续选择！`;
            this.btnNums=1;
            this.confirmText = "我知道了";
            this.tipType=1;
            this.tipShow=true;
            return;
        }
        let index = this.selectedList.findIndex(vv=>vv.id==item.id) 
        if(index>-1){
            let childIndex = this.selectedList[index].childList.findIndex(vv=>vv.id==v.id);
            if(childIndex>-1){
                if(this.type=='edit'){
                    this.tipTitle = "操作提醒";
                    this.tipText = `确定删除该规格吗？`;
                    this.btnNums=2;
                    this.confirmText = "确认";
                    this.cancelText = "取消"
                    this.tipType = 2;
                    this.tipItem = item;
                    this.tipV = v;
                    if(this.oldInfo.addGoodsItemsList.some(j=>j.stock&&j.stock>0&&j.updateType==2&&j.goodsSpecsId.indexOf(v.id)>-1)){
                        console.log('sss',this.oldInfo.addGoodsItemsList,v.id);
                        
                        this.tipText = `该规格下的商品存在库存，无法移除！`;
                        this.confirmText = "我知道了";
                        this.btnNums=1;
                        this.tipType = 3;
                    }
                    // let newIndex = this.oldInfo.oldSpecsSelectedList.findIndex(v=>v.id==item.id)
                    // if(newIndex>-1){
                    //     if(this.oldInfo.addGoodsItemsList.some(v=>v.stock&&v.stock>0&&this.oldInfo.oldSpecsSelectedList[newIndex].childList.some(j=>v.goodsSpecsId.indexOf(j.id)>-1))){
                    //         this.tipText = `该规格下的商品存在库存，无法移除！`;
                    //         this.confirmText = "我知道了";
                    //         this.btnNums=1;
                    //         this.tipType = 3;
                    //     }
                    // }
                    this.tipShow = true;
                }else{
                    this.selectedList[index].childList.splice(childIndex,1)
                    if(this.selectedList[index].childList.length==0){
                        this.selectedList.splice(index,1);
                    }
                }
            }else{
                this.selectedList[index].childList.push({
                    id:v.id,
                    name:v.name,
                    parentId:item.id
                })
            }
        }else{
            this.selectedList.push({
                id:item.id,
                name:item.name,
                childList:[{
                    id:v.id,
                    name:v.name,
                    parentId:item.id
                }]
            })
        }
    }

    /**提示弹窗 */
    async tipConfirm(){
        switch (this.tipType) {
            case 1:
                
                break;
            case 2:
                this.cdFun();
                break;
        
            default:
                break;
        }
        this.tipShow = false;
    }
    cdFun(){
        let index = this.selectedList.findIndex(vv=>vv.id==this.tipItem.id) 
        let childIndex = this.selectedList[index].childList.findIndex(vv=>vv.id==this.tipV.id);

        this.selectedList[index].childList.splice(childIndex,1)
        if(this.selectedList[index].childList.length==0){
            this.selectedList.splice(index,1);
        }
    }
    tipCancel(){
        this.tipShow = false;
    }

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/selectSpecsPanel.vue